import { render, staticRenderFns } from "./AgendaElencoAppuntamenti.vue?vue&type=template&id=3b1c3d9a"
import script from "./AgendaElencoAppuntamenti.vue?vue&type=script&lang=js"
export * from "./AgendaElencoAppuntamenti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports